module.exports = __webpack_public_path__ + "img/anxiety-icon-2.fff78ac9.svg";